import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IPtDate } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { ptDateColumns } from "./components/ptDateColumns";
import { ptDateSearchFields } from "./components/ptDateSearchFields";

export const PtDateList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IPtDate>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }],
            },
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="설명회 회차별 정원 및 신청 현황"
            />

            <SearchToolbar
                fields={ptDateSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={ptDateColumns}
                isError={tableQueryResult.isError}
                errorMessage="설명회 회차 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 설명회 회차가 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                getRowShowPath={(row) => `/ptDates/show/${row.id}`}
            />
        </List>
    );
};
